import { useReducer } from "react";
import {
  ContactState,
  ContactFailureResponse,
  ContactSuccessResponse,
} from "./types";
import * as ActionType from "./actions";

const initialState: ContactState = {
  contact: {} as ContactSuccessResponse,
  error: {} as ContactFailureResponse,
  isLoading: false,
};

const contactReducer = (
  state: ContactState,
  action: {
    type: string;
    payload: any;
  }
): ContactState => {
  switch (action.type) {
    case ActionType.CONTACTUS_SUBMIT_SUCCESS:
      return {
        contact: action.payload,
        error: initialState.error,
        isLoading: false,
      };
    case ActionType.CONTACTUS_SUBMIT_FAILURE:
      return {
        contact: initialState.contact,
        error: action.payload.error,
        isLoading: false,
      };
    case ActionType.CONTACTUS_SUBMIT_INPROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case ActionType.CLEAR_CONTACTUS_MESSAGE:
      return initialState;
    default:
      throw new Error();
  }
};

const useContact = () => {
  const [contactState, dispatch] = useReducer(contactReducer, initialState);
  return {
    contactState,
    dispatch,
  };
};

export { initialState, useContact };
